import React, { useEffect, useState } from 'react'
import { Card, Accordion, Button } from 'react-bootstrap';
import { useParams, useRouteMatch, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Truncate from "react-truncate";
import Tooltip from "components/Tooltip";

import _ from 'lodash';
import cx from 'classnames';
import dateformat from "dateformat";

import { createMarketoForm, updateMarketoForm } from 'actions/forms/marketo';
import { fetchForm, toggleFormManageView } from 'actions/forms/forms';
import { fetchMarketoForms, selectMarketoForm } from 'actions/integrations/marketo';

import { getBaseUrl } from 'services/util';
import CustomToggle from '../../components/customToggle';
import FormPreview, { MarketoFormPreview } from '../../components/formPreview';
import InfiniteScroll from "components/InfiniteScroll";

import styles from '../../forms.module.scss';

import {
  Form,
  InputGroup
} from "react-bootstrap";


export default function MarketoFormConfigurations(props) {
  const dispatch = useDispatch();

  const history = useHistory();
  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const [searchQuery, setSearchQuery] = useState('');
  const [tooltip, setTooltip] = useState(false);

  const selectedForm = useSelector(state => _.get(state, "integrations.marketo.forms.selectedForm", null));
  const currentForm = useSelector(state => _.get(state, "forms.currentForm", null));
  const forms = useSelector(state => _.get(state, `forms.items`, null));
  const page = useSelector(state => _.get(state, "integrations.marketo.forms.page", 0));

  const [state, setState] = useState({
    formPreview: false,
    activatedKey: "1",
    showSearch: true,
    testCompleted: false
  })

  useEffect(() => {
    dispatch(toggleFormManageView(true))

    return () => {
      dispatch(toggleFormManageView(false))
    };
  }, [])

  useEffect(() => {
    const request = {
      page: 0,
      limit: 20,
      query: searchQuery.trimStart()
    }

    dispatch(fetchMarketoForms(request));

  }, [])

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const request = {
        page: 0,
        limit: 20,
        query: searchQuery.trimStart()
      }

      dispatch(fetchMarketoForms(request));
    }
  }

  const handleSaveClick = () => {
    var domain = _.get(selectedForm, "configuration.domain", null);

    if (selectedForm && !domain) {
      const { hostname } = new URL(selectedForm.url);
      domain = `https://${hostname}`
    }

    setState(state => {
      return {
        ...state,
        testCompleted: false,
        showSearch: false,
        activatedKey: "2"
      }
    })

    if (selectedForm && !currentForm) {
      var createFormRequest = {
        name: selectedForm.name,
        formId: selectedForm.id,
        domain: domain,
        type: "marketo"
      }

      dispatch(createMarketoForm(createFormRequest))
    }

    if (selectedForm && currentForm && (selectedForm.id != currentForm.configuration.id)) {

      var updateRequest = {
        id: currentForm.id,
        formId: selectedForm.id
      }

      dispatch(updateMarketoForm(updateRequest))
    }
  }

  const handleTestClick = () => {
    setState(state => {
      return {
        ...state,
        formPreview: true
      }
    })
  }


  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }

  const handleClose = () => {
    setState(state => {
      return {
        ...state,
        activatedKey: "3",
        formPreview: false,
        testCompleted: false
      }
    })
  }

  const handleCustomToggle = (key) => {
    setState(state => {
      return {
        ...state,
        activatedKey: key,
        showSearch: key == '2' ? false : !state.showSearch,
        testCompleted: false
      }
    })
  }

  const handleFormSubmit = () => {
    setState(state => {
      return {
        ...state,
        formPreview: false,
        testCompleted: true,
        activatedKey: "3"
      }
    })
  }

  const handleDoneContainer = () => {
    var url = `${baseUrl}/integration-settings/forms?type=marketo`;
    history.push(url);
  }

  return (
    <div className={styles.formConfigurationContainer}>
      <Accordion className={styles.accordion} defaultActiveKey={state.activatedKey}>
        <Card>
          <Card.Header className={cx(styles.table, { [styles.completed]: state.activatedKey != "1" })}>
            <div className={styles.title} >
              <div className={styles.icon}>
                {state.activatedKey != "1" ? <i className="cleverstory-tick"></i> : "1"}
              </div>
              <div className={styles.name}>Select a Marketo Form</div>
            </div>

            <div className={styles.searchSelect}>
              {state.showSearch &&
                  <InputGroup className={styles.searchBox}>
                    <InputGroup.Text className={styles.searchIcon} id="basic-addon1">
                      <i className="cleverstory-search" />
                    </InputGroup.Text>
                    <Form.Control
                      className={styles.searchInput}
                      onKeyDown={handleKeyDown}
                      placeholder="Type here"
                      aria-label="Type here"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      aria-describedby="basic-addon1"
                    />
                  </InputGroup>
              }

              {selectedForm &&
                <>
                  <div className={styles.divider}></div>
                  <div className={styles.selectedForm}>
                    <div className={styles.title}>Selected form: </div>
                    <Tooltip placement="top" content={selectedForm.name} disabled={!tooltip}>
                      <Truncate width={200} ellipsis={(<span>...</span>)} onTruncate={handleTooltip} lines={1}>
                        {selectedForm.name}
                      </Truncate>
                    </Tooltip>
                  </div>
                </>}
            </div>
            <CustomToggle eventKey="1" onClick={() => handleCustomToggle("1")}>Choose a different form</CustomToggle>
          </Card.Header>
          <Accordion.Collapse  eventKey="1">
            <Card.Body>
              <MarketoForms searchQuery={searchQuery} />
              <div className={cx(styles.bottom, styles.doneButtonContainer, styles.table)}>
                <CustomToggle eventKey="1" onClick={() => handleSaveClick()} isComplete={true} disabled={!selectedForm}>Save & Continue</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Card.Header className={cx({ [styles.disabled]: parseInt(state.activatedKey) < 2 }, { [styles.completed]: parseInt(state.activatedKey) > 2 })}>
            <div className={styles.title}>
              <div className={styles.icon}>
                {parseInt(state.activatedKey) > 2 ? <i className="cleverstory-tick"></i> : "2"}
              </div>
              <div className={styles.name}>Test the code</div>
            </div>
            {state.testCompleted && <div className={styles.success}>Test Successfull</div>}
            {!state.testCompleted && <CustomToggle eventKey="2" onClick={() => handleCustomToggle("2")}>Test the form</CustomToggle>}
          </Card.Header>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              <TestTheCode />
              <div className={cx(styles.bottom, styles.doneButtonContainer, styles.table)}>
                <CustomToggle eventKey="2" onClick={() => handleTestClick()} isComplete={true}>Test the Code</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      {state.formPreview &&
        <FormPreview preview={state.formPreview} editable={true} form={currentForm} onClose={handleClose} onFormSubmit={() => handleFormSubmit()} />
      }

      {parseInt(state.activatedKey) > 1 &&
        <div className={styles.finishButton}>
          <Button className={styles.actionButton}
            onClick={handleDoneContainer}
            size="sm"
            variant="primary"
          >
            Done
          </Button>
        </div>
      }
    </div>
  );
}

function MarketoForms(props) {
  const dispatch = useDispatch();
  const page = useSelector(state => _.get(state, "integrations.marketo.forms.page", 0));
  const loading = useSelector(state => _.get(state, "integrations.marketo.forms.loading", false));
  const loadMoreResults = useSelector(state => _.get(state, "integrations.marketo.forms.loadMore", 0));
  const currentForm = useSelector(state => _.get(state, "forms.currentForm", null));

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type == 'marketo';
  });

  const forms = useSelector(state => _.get(state, "integrations.marketo.forms.items", []));
  const headers = ["Name", "Created on", "Updated on"];
  const selectedForm = useSelector(state => _.get(state, "integrations.marketo.forms.selectedForm", null));

  const [selectedFormId, setSelectedFormId] = useState(null);
  const { formId } = useParams();
  const munchkinId = _.get(integration, 'configuration.munchkinId', null);

  const loadMore = () => {

    if (props.searchQuery !== '') {
      return
    }

    const request = {
      page: page,
      limit: 20,
      query: props.searchQuery.trimStart()
    }

    dispatch(fetchMarketoForms(request));
  }

  useEffect(() => {
    if (formId && formId != "new") {
      dispatch(fetchForm(formId))
      return;
    }
  }, [formId])

  useEffect(() => {
    if (currentForm) {
      var formId = _.get(currentForm, 'configuration.formId', null);
      setSelectedFormId(formId)
      dispatch(selectMarketoForm(currentForm))
    }
  }, [currentForm])

  const handleSelectForm = (form) => {
    setSelectedFormId(form.id);
    dispatch(selectMarketoForm(form))
  }

  const getFormattedDate = (dateString) => {
    let date = dateString.split("T")[0];
    return dateformat(date, "dd mmm yyyy")
  }

  const renderMarketoForm = (form) => {
    var domain = _.get(form, "configuration.domain", null);

    if (form && !domain) {
      const { hostname } = new URL(form.url);
      domain = `https://${hostname}`
    }

    if (!form.configuration) {
      form = {
        configuration: {
          munchkinId: munchkinId,
          domain: domain,
          formId: selectedFormId
        }
      }
    }

    return (
      <MarketoFormPreview editable={false} form={form} onFormSubmit={() => { }} />
    )
  }

  return (
    <div className={styles.externalFormContainer}>
      <div className={styles.left}>
        <div className={styles.formData}>
          <div className={cx(styles.row, styles.no_border)}>
            <div className={cx(styles.container, styles.no_border)}>
              {headers.map(header => {
                return (
                  <div className={styles.column}>{header}</div>
                )
              })}
            </div>
          </div>
          {loading && forms.length == 0 && <div className={styles.loadingMessage}>Loading Forms ...</div>}
          {_.size(forms) == 0 && <div className={styles.loadingMessage}>No forms found !</div>}
          {forms.length > 0 && <InfiniteScroll
            className={cx(styles.scrollable)}
            loading={loading}
            hasMore={loadMoreResults && _.size(props.searchQuery) === 0}
            loadMore={() => { loadMore() }}>

            {forms.map(form => {
              var isActive = form && form.id === selectedFormId;
              const createdDate = _.get(form, 'createdAt');
              const updatedDate = _.get(form, 'updatedAt');

              return (
                <FormData form={form} isActive={isActive} getFormattedDate={getFormattedDate} handleSelectForm={handleSelectForm}
                  selectedFormId={selectedFormId} createdDate={createdDate} updatedDate={updatedDate} />
              )
            })}
          </InfiniteScroll>}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.contactForm} id="contact_form">
          {!selectedFormId && !selectedForm && <div>Select any form to display !</div>}
          {selectedForm && renderMarketoForm(selectedForm)}
        </div>
      </div>
    </div>
  )
}

function FormData({ form, handleSelectForm, selectedFormId, isActive, getFormattedDate, createdDate, updatedDate }) {
  const [tooltip, setTooltip] = useState(false);

  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }

  return (
    <div onClick={() => handleSelectForm(form)} className={cx(styles.row, { [styles.active]: isActive })}>
      <div className={styles.container}>
        <div className={cx(styles.radioButton, styles.column)} >
          <input type="radio" checked={selectedFormId === form.id}></input>
          <label className={cx(styles.formName)}>
            <Tooltip placement="top" content={form.name} disabled={!tooltip}>
              <Truncate width={200} ellipsis={(<span>...</span>)} onTruncate={handleTooltip} lines={1}>
                {form.name}
              </Truncate>
            </Tooltip>
          </label>
        </div>
        <div className={cx(styles.data, styles.column)}>{getFormattedDate(createdDate)}</div>
        <div className={cx(styles.data, styles.column)}>{getFormattedDate(updatedDate)}</div>
      </div>
    </div>
  )
}

function TestTheCode() {
  return (
    <div className={styles.bodyContainer}>
      <div className={styles.testTheCode}>
        <div className={styles.tcContent}>
          Just to make sure everything's working the way it has to, please test the form by entering sample data. If the test is successful, the sample entry should be recorded in your database. Incase the test is unsuccessful, please recheck the connection with the third party application where you’re importing the form from.         </div>
      </div>
    </div>
  )
}